import { ArchiveArrowDownOutlineIcon } from './ArchiveArrowDownOutlineIcon';

/**
 * author: frankgrinaert
 * id 133BA980-E797-4DB3-9C92-F59AC3DB3399
 * name archive-arrow-down-outline
 * version: 4.7.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/archive-arrow-down-outline.svg
 * tags
 */
export const ThisSideDownOutlineIcon = ArchiveArrowDownOutlineIcon;
export default ThisSideDownOutlineIcon